import { pickAdminDashboardLocaleText } from "../locale/admin-dashboard-copy";
import type { AdminDashboardLocale } from "../locale/admin-dashboard-locale";
import type { AdminStateMetaItem } from "./admin-empty-state";

export function formatAdminStateTimeRangeLabel(from: string, to: string): string {
  return `${from} -> ${to}`;
}

export function buildAdminStateTimeRangeMeta(
  locale: AdminDashboardLocale,
  from: string,
  to: string,
): AdminStateMetaItem {
  return {
    key: "timeRange",
    label: pickAdminDashboardLocaleText(locale, { en: "Range", ko: "범위" }),
    value: formatAdminStateTimeRangeLabel(from, to),
  };
}

export function buildAdminStateScopeMeta(
  locale: AdminDashboardLocale,
  summary: string | undefined,
): AdminStateMetaItem | undefined {
  if (!summary) {
    return undefined;
  }

  return {
    key: "scope",
    label: pickAdminDashboardLocaleText(locale, { en: "Scope", ko: "범위" }),
    value: summary,
  };
}

export function buildAdminStateLookupMeta(
  locale: AdminDashboardLocale,
  summary: string | undefined,
): AdminStateMetaItem | undefined {
  if (!summary) {
    return undefined;
  }

  return {
    key: "lookup",
    label: pickAdminDashboardLocaleText(locale, { en: "Lookup", ko: "조회 기준" }),
    value: summary,
  };
}

export function buildAdminStateRouteMeta(
  locale: AdminDashboardLocale,
  route: string,
): AdminStateMetaItem {
  return {
    key: "route",
    label: pickAdminDashboardLocaleText(locale, { en: "Route", ko: "화면" }),
    value: route,
  };
}
